import type Button from "../../../src/models/Button";
import type { Model3DDefinition } from "./Model3D";
import type { GlassButtonOptions } from "./buttonModels/ButtonModelParameters";
import { genericTouchButtonModel, mdtGlassButtonModel } from "./buttonModels/catalog";
import { cleanDecode } from "../../../src/utils/CommonUtils";

export interface ButtonProduct3DMapping {
  readonly model: Model3DDefinition<GlassButtonOptions>;
  readonly parameters: Readonly<Partial<GlassButtonOptions>>;
}

/** Explicit product assignments. Extend this table when adding concrete product models. */
export const buttonProduct3DMappings: ReadonlyMap<string, ButtonProduct3DMapping> = new Map<string, ButtonProduct3DMapping>([
  ["BE-GT2TW.02", { model: mdtGlassButtonModel, parameters: { color: "white" } }],
  ["BE-GT2TS.02", { model: mdtGlassButtonModel, parameters: { color: "black" } }],
  ["BE-GT2TS.02S", { model: mdtGlassButtonModel, parameters: { color: "black" } }],
  ["BE-GT2TX.02", { model: mdtGlassButtonModel, parameters: {} }],
  ["BE-GT20W.02", { model: mdtGlassButtonModel, parameters: { color: "white" } }],
  ["BE-GT20S.02S", { model: mdtGlassButtonModel, parameters: { color: "black" } }],
  ["BE-GT20X.02", { model: mdtGlassButtonModel, parameters: {} }],
]);

const genericMapping: ButtonProduct3DMapping = { model: genericTouchButtonModel, parameters: {} };

export function getButtonProduct3DMapping(device: Pick<Button, "template">): ButtonProduct3DMapping {
  const template = device.template;
  // KNX metadata often names the whole family (e.g. BE-GT2Tx.02).
  // The selected concrete variant is stored separately and takes precedence.
  for (const number of [template?.orderInformation?.articleNo, template?.knxProductData?.productInfo?.OrderNumber]) {
    if (!number) continue;
    const mapping = buttonProduct3DMappings.get(cleanDecode(number).trim().toUpperCase());
    if (mapping) return mapping;
  }
  return genericMapping;
}
